module.exports = __webpack_public_path__ + "img/PPC-alt.dd4633f1.svg";